import React from "react";
import { FaTelegram } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

interface PlatformIconProps {
  platform: string;
  size?: number;
}

export const PlatformIcon = ({ platform, size = 20 }: PlatformIconProps) => {
  if (platform === "WHATSAPP") {
    return <FaWhatsapp size={size} style={{ color: "#25D366" }} />;
  } else if (platform === "INSTAGRAM") {
    return <FaInstagram size={size} style={{ color: "#C13584" }} />;
  } else if (platform === "TELEGRAM") {
    return <FaTelegram size={size} style={{ color: "#0088cc" }} />;
  }
  return <FaGlobe size={size} style={{ color: "#FFA500" }} />;
};
